import { Link } from "react-router-dom";

const CommunicationStrip = () => (
  <section id="contact" className="py-14 bg-gradient-to-r from-[#D4AF37] via-[#c9a227] to-[#D4AF37]">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1a0a0a] mb-2">
          Connect with Suppliers Instantly
        </h2>
        <p className="text-[#1a0a0a]/70 text-sm">
          Get quotes, negotiate prices, and track orders in real time via WhatsApp or CrownChat.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-10">
        {/* WhatsApp */}
        <a
          href="https://wa.me/1234567890"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-4 bg-white rounded-lg px-8 py-5 hover:scale-105 transition-transform cursor-pointer w-full sm:w-auto"
        >
          <div className="w-12 h-12 flex items-center justify-center bg-[#25D366] rounded-full flex-shrink-0">
            <i className="ri-whatsapp-line text-white text-2xl"></i>
          </div>
          <div>
            <div className="font-bold text-gray-900 text-base">WhatsApp</div>
            <div className="text-gray-500 text-xs">Chat with suppliers directly</div>
            <div className="text-[#25D366] text-xs font-semibold mt-1">+1 (234) 567-8900</div>
          </div>
        </a>

        <div className="text-[#1a0a0a]/40 font-bold text-lg hidden sm:block">OR</div>

        {/* CrownChat */}
        <Link to="/crownchat" className="flex items-center gap-4 bg-white rounded-lg px-8 py-5 hover:scale-105 transition-transform cursor-pointer w-full sm:w-auto">
          <div className="w-12 h-12 flex items-center justify-center bg-[#C41E3A] rounded-full flex-shrink-0">
            <i className="ri-message-3-line text-white text-2xl"></i>
          </div>
          <div>
            <div className="font-bold text-gray-900 text-base">CrownChat</div>
            <div className="text-gray-500 text-xs">Video calls, messaging &amp; more</div>
            <div className="text-[#C41E3A] text-xs font-semibold mt-1">App Store &amp; Google Play ↗</div>
          </div>
        </Link>
      </div>

      {/* Features */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { icon: "ri-time-line", label: "Instant Response", desc: "Average reply in under 5 minutes" },
          { icon: "ri-translate-2", label: "Multilingual", desc: "English, French, Chinese support" },
          { icon: "ri-file-list-3-line", label: "Quote Requests", desc: "Get bulk pricing instantly" },
          { icon: "ri-map-pin-line", label: "Order Tracking", desc: "Real-time shipment updates" },
        ].map((f) => (
          <div key={f.label} className="bg-white/60 rounded-lg p-4 text-center">
            <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
              <i className={`${f.icon} text-[#1a0a0a] text-xl`}></i>
            </div>
            <div className="font-bold text-[#1a0a0a] text-sm">{f.label}</div>
            <div className="text-[#1a0a0a]/60 text-xs mt-1">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CommunicationStrip;
